module.exports = __webpack_public_path__ + "static/img/web-services.db0bcb0b.jpg";